module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "g-recaptcha",
    attrs: {
      "id": "g-recaptcha",
      "data-sitekey": _vm.sitekey,
      "data-badge": "inline"
    }
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-80df3016"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/Recaptcha.vue
// module id = 988
// module chunks = 1